import { Selector } from "react-redux";

import { IAppState } from "@multiweb/types/react";
import { ILinkButtonState } from "./types";

/**
 * Získá z globálního stavu instanci patřící LinkButton podle `dataKey`.
 * Pokud pro daný klíč neexistuje instance, vrací undefined.
 *
 * @param state
 * @param dataKey Klíč k instanci LinkButton.
 */
export const getLinkButtonInstance: Selector<IAppState, Readonly<ILinkButtonState> | undefined, string> = (
    state: IAppState,
    dataKey: string,
): ILinkButtonState => state.linkButton[dataKey];

/**
 * Získá z globálního stavu informaci o načítání patřící LinkButton podle `dataKey`.
 *
 * @param state
 * @param dataKey Klíč k instanci LinkButton.
 */
export const getIsLoading: Selector<IAppState, boolean, string> = (state: IAppState, dataKey: string): boolean => state.linkButton[dataKey].isLoading;
